import { render, staticRenderFns } from "./ratings.vue?vue&type=template&id=f4a0e0ce&scoped=true&"
import script from "./ratings.vue?vue&type=script&lang=js&"
export * from "./ratings.vue?vue&type=script&lang=js&"
import style0 from "./ratings.vue?vue&type=style&index=0&id=f4a0e0ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a0e0ce",
  null
  
)

export default component.exports